import React, { forwardRef, useEffect, useRef } from 'react'

export interface IScanImageProps
  extends React.ImgHTMLAttributes<HTMLImageElement> {}

const ScanImage = forwardRef<HTMLImageElement, IScanImageProps>(
  (props, ref) => {
    const { src, crossOrigin, ...restProps } = props

    const imageRef = useRef<HTMLImageElement>(null)

    useEffect(() => {
      const imgRefCopy = imageRef.current

      if (imageRef) return
      imgRefCopy.src = src
      return () => {
        if (imgRefCopy) {
          imgRefCopy.src = ''
        }
      }
    }, [])

    return (
      <img
        ref={(_ref) => {
          imageRef.current = _ref
          if (typeof ref === 'function') {
            ref(_ref)
          } else if (ref) {
            ;(ref as React.MutableRefObject<HTMLImageElement | null>).current =
              _ref
          }
        }}
        src={src}
        {...restProps}
      />
    )
  },
)

export default ScanImage
